import { useParams, Navigate } from "react-router-dom";
import { Footer } from "@/components/landing/Footer";
import { PageHeader } from "@/components/landing/PageHeader";
import { RegisterForm } from "@/components/ambassadors/RegisterForm";
import { LoginForm, ForgotForm, ResetForm } from "@/components/ambassadors/AuthForms";

const COPY = {
  register: { kicker: "Ambassador Crew · Apply", a: "Join the", b: "Crew", text: "Tell us who you are, where you promote and where to send your commissions. We review every application personally." },
  login: { kicker: "Ambassador Crew · Sign in", a: "Welcome", b: "back", text: "Your link, your sales and what you've earned — all in one place." },
  forgot: { kicker: "Ambassador Crew · Reset", a: "Forgot your", b: "password?", text: "Enter the email you signed up with and we'll send a reset link." },
  reset: { kicker: "Ambassador Crew · Reset", a: "Choose a new", b: "password", text: "Pick something you'll remember — at least 8 characters." },
};

export default function AmbassadorAuth() {
  const { mode = "login" } = useParams();
  const c = COPY[mode];
  if (!c) return <Navigate to="/ambassadors/login" replace />;
  const wide = mode === "register";
  return (
    <main data-testid={`ambassador-${mode}-page`} className="bg-[#ffffff] text-[#0a0a0b] min-h-screen antialiased">
      <PageHeader page={`ambassador-${mode}`} link={{ id: "crew", to: "/ambassadors", label: "Ambassador Crew" }} />
      <section className="relative pt-32 sm:pt-40 pb-20 px-5 sm:px-8 overflow-hidden">
        <div className="absolute inset-0 hero-radial" />
        <div className={`relative mx-auto grid gap-10 ${wide ? "max-w-[1200px] lg:grid-cols-12" : "max-w-[1000px] lg:grid-cols-12"}`}>
          <div className={wide ? "lg:col-span-4" : "lg:col-span-6"}>
            <p className="font-mono-d text-[11px] uppercase tracking-[0.3em] text-[#ff2a85] mb-6 flex items-center gap-3"><span className="diamond" /> {c.kicker}</p>
            <h1 className="font-display font-extrabold uppercase leading-[0.9] text-4xl sm:text-5xl lg:text-6xl tracking-tight">{c.a} <span className="text-pink">{c.b}</span></h1>
            <p className="mt-7 text-[#5f5e5a] text-base sm:text-lg leading-relaxed max-w-md">{c.text}</p>
          </div>
          <div className={wide ? "lg:col-span-8" : "lg:col-span-6"}>
            <div className={wide ? "" : "rounded-3xl border border-[#e3e2dc] bg-[#faf9f6] p-6 sm:p-8"}>
              {mode === "register" ? <RegisterForm /> : mode === "forgot" ? <ForgotForm /> : mode === "reset" ? <ResetForm /> : <LoginForm />}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
